import React, { useEffect, useRef } from "react";
import { Line, Plane, Billboard, Text, Edges } from "@react-three/drei";
import { useThree } from "@react-three/fiber";
import * as THREE from "three";

import { useFrame } from "@react-three/fiber";
import { TOOTH_GUM_TYPE } from "../../../data/constant/toothConstant";
import { checkIPRVisible } from "../../../data/util/iprUtil";

function IPRModel(props) {
  const { value, startPosition, endPosition, visible = true } = props;
  const billboardRef = useRef();
  const groupRef = useRef();
  const { camera } = useThree();

  const startVector = new THREE.Vector3(
    startPosition.x,
    startPosition.y,
    startPosition.z
  );

  const endVector = new THREE.Vector3(
    endPosition.x,
    endPosition.y,
    endPosition.z
  );

  const getScale = () => {
    if (!billboardRef.current) {
      return 1;
    }
    const billboard = billboardRef.current;
    const distance = camera.position.distanceTo(billboard.position);
    const scale = (8 * distance) / 1920;
    return scale;
  };

  useFrame(() => {
    const scale = getScale();
    billboardRef.current.scale.set(scale, scale, scale);
  });

  return (
    <group ref={groupRef} visible={visible}>
      <Billboard
        ref={billboardRef}
        renderOrder={2}
        position={endVector}
        follow={true}
        lockX={false}
        lockY={false}
        lockZ={false}
      >
        {visible && (
          <Text fontSize={1} color={"black"} renderOrder={3}>
            {value || ""}
            <meshStandardMaterial
              transparent={true}
              depthTest={true}
              color="white"
            />
          </Text>
        )}
        <Plane args={[2, 2]} renderOrder={2}>
          <meshBasicMaterial
            transparent={true}
            depthTest={true}
            depthWrite={true}
            color={"white"}
          ></meshBasicMaterial>
          <Edges scale={1.0} threshold={15} color="black" />
        </Plane>
      </Billboard>
      <Line
        points={[startVector, endVector]}
        lineWidth={1}
        fog={false}
        depthTest={false}
        renderOrder={1}
        transparent={true}
      ></Line>
    </group>
  );
}

export default IPRModel;
